import script from "./ListarAulasReposicao.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarAulasReposicao.vue?vue&type=script&setup=true&lang=js"

import "./ListarAulasReposicao.vue?vue&type=style&index=0&id=c690a7ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c690a7ac"]])

export default __exports__